class DynamicAccordion2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.toggleAccordion);
  }

  connectedCallback() {
    if (this.hasAttribute('open')) {
      this.openAccordion();
    }
  }

  toggleAccordion(event) {
    const button = event.target.closest('[data-accordion-button]');
    if (!button) return;

    this.closeAllAccordions(button);

    this._toggle(button);
  }

  openAccordion() {
    const button = this.querySelector('[data-accordion-button]');
    if (button) {
      this._toggle(button, true);
    }
  }

  _toggle(button, forceOpen) {
    const isActive = button.classList.contains('active');
    if (forceOpen && isActive) return;

    button.classList.toggle('active', !isActive || forceOpen);
    const description = button.nextElementSibling;

    if (description && description.hasAttribute('data-accordion-description')) {
      description.classList.toggle('opened', !isActive || forceOpen);

      if (description.style.maxHeight && !forceOpen) {
        description.style.maxHeight = null;
      } else {
        description.style.maxHeight = description.scrollHeight + 'px';
      }
    }
  }

  closeAllAccordions(exceptButton) {
    const allButtons = this.parentNode.querySelectorAll('[data-accordion-button]');
    allButtons.forEach(button => {
      if (button !== exceptButton) {
        const isActive = button.classList.contains('active');
        if (isActive) {
          this._toggle(button, false);
        }
      }
    });
  }
}

customElements.define('dynamic-accordion', DynamicAccordion2);

class DrawerSlide extends HTMLElement {
  constructor() {
    super(); 
    this.drawer = this.querySelector('[data-drawer-content]');
  }

  connectedCallback() {
    const button = document.querySelector('[data-review-button]')
    button.addEventListener('click', (event) => {
        this.toggleDrawer();
    });

    this.drawer.querySelector('[data-review-button]').addEventListener('click', (event) => {
      this.toggleDrawer();
      event.stopPropagation();
    });
  }

  toggleDrawer() {
    const body = document.body;
    this.drawer.classList.toggle('open');
    if (this.drawer.classList.contains('open')) {
      body.classList.add('scroll-disabled');
    } else {
      body.classList.remove('scroll-disabled');
    }
    this.drawer.setAttribute('aria-hidden', this.drawer.classList.contains('open') ? 'false' : 'true');
  }
}

customElements.define('drawer-slide', DrawerSlide);

class TabsComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();
    this.initReadMoreButtons();
    this.initReadMoreContent();

    window.addEventListener('resize', ()=> {
      this.initReadMoreContent();
    });
  }

  initTabs() {
    const tabButtons = this.querySelectorAll('.tab-link');
    const tabPanels = Array.from(this.querySelectorAll('.tab-content'));
  
    tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', (event) => {
        const targetId = event.target.dataset.target;
        this.initReadMoreContent();
  
        tabPanels.forEach((tabPanel) => {
          if (tabPanel.id === targetId) {
            tabPanel.classList.add('is-active');
            tabPanel.classList.remove('is-hidden');

            const button = tabPanel.querySelector('.c-read-more--btn');
            if (button) {
              button.textContent = 'Read more'
            }
         
          } else {
            if (tabPanel.classList.contains('is-active')) {
              const expandedContent = tabPanel.querySelector('.c-read-more.expanded');
        
              if (expandedContent) {
                expandedContent.classList.remove('expanded');
                if(window.innerWidth >= 1650) {
                  expandedContent.style.height = '288px';
                }
                else if (window.innerWidth >= 1024) {
                  expandedContent.style.height = '225px';
                } else {
                  expandedContent.style.height = '142px';
                }
                
                const button = expandedContent.querySelector('.c-read-more--btn');
                if (button) button.textContent = 'Read more'; 
              }
              const contentContainer = tabPanel.closest('[data-tab-content]');
              if (contentContainer && contentContainer.classList.contains('content--active')) {
                contentContainer.classList.remove('content--active');
              }
            }
            tabPanel.classList.add('is-hidden');
            tabPanel.classList.remove('is-active');
          }
        });
  
        tabButtons.forEach(button => {
          if (button.dataset.target === targetId) {
            button.classList.add('is-active');
          } else {
            button.classList.remove('is-active');
          }
        });
      });
    });
  
    if (tabButtons.length > 0) {
      tabButtons[0].click();
    }
  }

  initReadMoreContent() {
    const tabPanelsContent = Array.from(this.querySelectorAll('.tab-content'));

    tabPanelsContent.forEach((tabPanel) => {
      
      let tabPanelContent = tabPanel.querySelector('.c-read-more');
      let tabPanelButtn = tabPanel.querySelector('.c-read-more--btn');

      if (tabPanelContent) {
        let tabPanelContentHeight = tabPanelContent.querySelector('.metafield-rich_text_field').clientHeight;
        let maximumHeight = 142;
        
        if(window.innerWidth >= 1650) {
          maximumHeight = 288;
          tabPanelContentHeight = tabPanelContentHeight - 31;
        }
        else if(window.innerWidth >= 1024) {
          maximumHeight = 225;
          tabPanelContentHeight = tabPanelContentHeight - 31;
        }
        if(tabPanelContentHeight >= maximumHeight) {
          tabPanelButtn.classList.remove('is-hidden');
          tabPanelContent.style.height = `${maximumHeight}px`;
        }
        else {
          tabPanelButtn.classList.add('is-hidden');
        }
      }

    });
  }

  initReadMoreButtons() {
    this.querySelectorAll('.c-read-more--btn').forEach(button => {
      button.addEventListener('click', (event) => {
        const tabPanel = event.target.closest('.tab-content');
        this.toggleReadMore(tabPanel);
        event.stopPropagation();
      });
    });
  }

  toggleReadMore(tabPanel) {
    const content = tabPanel.querySelector('.c-read-more');
    const button = tabPanel.querySelector('.c-read-more--btn');

    if (!content || !button) return;
  
    let initialHeight = '';
    if(window.innerWidth >= 1650) {
      initialHeight = '288px';
    }
    else if (window.innerWidth >= 1024) {
      initialHeight = '225px';
    } else {
      initialHeight = '142px';
    }
    const expanded = content.classList.contains('expanded');
    const newHeight = expanded ? initialHeight : `${content.scrollHeight}px`;
    const buttonText = expanded ? 'Read more' : 'Read less';
  
    content.style.height = newHeight;
    button.textContent = buttonText;
    content.classList.toggle('expanded');

    const contentContainer = content.closest('[data-tab-content]')
    contentContainer.classList.toggle('content--active');
  }
  
}

customElements.define('tabs-component', TabsComponent);


document.addEventListener('DOMContentLoaded', (event) => {

  var swiper = new Swiper(".c-product__swiper", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    }
  });
  
  document.querySelectorAll('[data-read-more]').forEach(function (item) {
    const showMoreBtn = item.querySelector('[data-show]');
    const showLessBtn = item.querySelector('[data-hide]');

    showMoreBtn.addEventListener('click', function () {

      item.classList.add('is-collapsed');
    });

    showLessBtn.addEventListener('click', function () {
      item.classList.remove('is-collapsed');
    });
  });

  // Update product score
  const productScoreTotal = document.querySelector('[data-total-score]');
  const productScoreProgress = document.querySelector('[data-progress-score]');

  if(productScoreTotal && productScoreProgress) {
    const productScoreTotalAmount = productScoreTotal.dataset.totalScore;
    const productProgress = productScoreTotal.dataset.progressScore;

    const progressScore = `${(productProgress * 100) / productScoreTotalAmount}`;
    productScoreTotal.style.setProperty('--progress', progressScore);
  }
  
  let tabs = document.querySelector('.c-featured-carousel__tabs');

  if(tabs) {
    let tabButtons = document.querySelectorAll('.c-featured-carousel__tab-link');
    let tabPanels = Array.from(document.querySelectorAll('.c-featured-carousel__tab-content'));
  
    function showPanel(panel) {
      tabPanels.forEach((tabPanel) => {
        if (tabPanel.id === panel) {
          tabPanel.classList.add('is-active');
          tabPanel.classList.remove('is-hidden');
        } else {
          tabPanel.classList.add('is-hidden');
          tabPanel.classList.remove('is-active');
        }
      });
    }
  
    function setActiveButton(targetId) {
      tabButtons.forEach((tabButton) => {
        if (tabButton.dataset.target === targetId) {
          tabButton.classList.add('is-active');
        } else {
          tabButton.classList.remove('is-active');
        }
      });
    }
  
    tabs.addEventListener('click', (event) => {
      if (event.target.classList.contains('c-featured-carousel__tab-link')) {
        showPanel(event.target.dataset.target);
        setActiveButton(event.target.dataset.target);
      }
    });
  
    const defaultTabId = tabButtons[0].dataset.target;
    showPanel(defaultTabId);
    setActiveButton(defaultTabId);
  }

  // Product scroll to tab content
  const productMaker = document.querySelector('[data-scroll-maker-tabs]');
  const productMakerContent = document.querySelector('[data-maker-content]');

  if(productMaker && productMakerContent) {
    productMaker.addEventListener('click', ()=> {
      let productMakerContentPosition = productMakerContent.offsetTop;

      window.scroll({ top: productMakerContentPosition, behavior: 'smooth' });
    });
  } 

  setTimeout(() => {
    function handleContainerHeight() {
      if (window.innerWidth >= 1024) {
        const tabContainer = document.querySelector('[data-tabs-container]');
        const images = document.querySelectorAll('[data-image-height]');
  
        if (images.length > 0 && tabContainer) {
          let maxHeight = 0;
  
          images.forEach(image => {
            const imageHeight = image.clientHeight;
  
            if (imageHeight > maxHeight) {
              maxHeight = imageHeight;
            }
          });
  
          tabContainer.style.setProperty('--tab-height', `${maxHeight}px`);
        }
      }
    }
  
    handleContainerHeight();
  
    window.addEventListener('resize', handleContainerHeight);
  }, 1000);
  
});
